// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__cfZw5","Success":"Button_Success__3StBq","Danger":"Button_Danger__zMEy_"};